import React from 'react'
import c from 'classnames'
import Icon from 'discada/dist/Icon'

import { cn, COMPLETE_STOP, COMPLETE_ICON, PROGRESS_MAX } from './index'

export function Ring(props) {
  const {
      radius = 50,
      strokeWidth = 2,
      stop = {},
      finishContent = COMPLETE_STOP,
    } = props,
    { name, icon } = stop,
    progress = Math.max(5, props.progress),
    normalizedRadius = radius - strokeWidth * 2,
    circumference = normalizedRadius * 2 * Math.PI,
    strokeDashoffset = circumference - (progress / 100) * circumference,
    complete = progress >= PROGRESS_MAX

  return (
    <div
      className={c(cn('ring'), {
        [cn('ring-complete')]: complete,
      })}
    >
      <div className={cn('ring-icon')}>
        <Icon className="fa-fw" icon={complete ? COMPLETE_ICON : icon} />
        <svg height={radius * 2} width={radius * 2}>
          <circle
            strokeDasharray={circumference}
            style={{ strokeDashoffset }}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
      </div>
      <strong className={cn('ring-name')}>
        {complete ? finishContent : name}
      </strong>
    </div>
  )
}

export default Ring
